<app-modal-header [title]="config?.infoTitle ?? config?.name ?? ''" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="text-gray-600 text-sm" *ngIf="config">

    <p *ngFor="let p of config?.infoDescription" class="mb-3">{{ p }}</p>

    <ng-container *ngIf="config?.pricingRows?.length">
      <div class="flex items-baseline justify-between mb-3">
        <p class="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
          <i class="fas fa-tag text-[11px]"></i>
          Pricing
        </p>
        <span class="text-xs text-gray-400" *ngIf="config.pricingLabel">billed per {{ config.pricingLabel | lowercase }}</span>
      </div>

      <div class="rounded-control border border-gray-100 bg-gray-50/60 divide-y divide-gray-100" *ngIf="baseRows.length">
        <div class="flex items-center justify-between gap-3 px-3.5 py-2.5" *ngFor="let row of baseRows">
          <div class="min-w-0">
            <div class="font-medium text-gray-700">{{ row.service }}</div>
            <div class="text-xs text-gray-400" *ngIf="row.included">{{ row.included }}</div>
          </div>
          <span class="shrink-0 rounded-full bg-white border border-gray-200 px-2.5 py-1 font-mono text-xs font-semibold text-primary-700">{{ row.cost }}</span>
        </div>
      </div>

      <div class="mt-3" *ngIf="optionalRows.length">
        <p class="mb-1.5 flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-gray-400">
          <i class="fas fa-sliders text-[11px]"></i>
          Optional add-ons
        </p>
        <div class="space-y-1.5">
          <div class="flex items-center justify-between gap-3 rounded-control border border-dashed border-gray-200 bg-gray-50 px-3.5 py-2" *ngFor="let row of optionalRows">
            <div class="min-w-0">
              <div class="text-gray-700">{{ row.service }}</div>
              <div class="text-xs text-gray-400" *ngIf="row.included">{{ row.included }}</div>
            </div>
            <span class="shrink-0 rounded-full bg-white border border-gray-200 px-2.5 py-1 font-mono text-xs font-semibold text-gray-900">+{{ row.cost }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ul *ngIf="config?.pricingNotes?.length" class="mt-3 space-y-1.5 border-gray-100 pt-3">
      <li *ngFor="let note of config.pricingNotes" class="flex items-start gap-2 text-xs text-gray-400">
        <i class="fas fa-circle-info mt-0.5 shrink-0 text-gray-300"></i>
        <span>{{ note }}</span>
      </li>
    </ul>

    <div *ngIf="config?.poweredBy" class="mt-5 flex items-center justify-end gap-2 border-t border-gray-100 pt-3">
      <span class="text-xs text-gray-300">Powered by</span>
      <a [href]="config.poweredBy?.url" [title]="config.poweredBy?.name" target="_blank" class="opacity-50 transition-opacity hover:opacity-80">
        <img [src]="config.poweredBy?.logo" [alt]="config.poweredBy?.name" class="h-5 rounded">
      </a>
    </div>

  </div>
</mat-dialog-content>
